var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { creditHealthCacheKey } from "../cacheKeys.js";
import mutationFnFactory from "./mutation.js";
function useCreditHealthMutation({
  config,
  mutationOptions = {}
}) {
  const queryClient = useQueryClient();
  return useMutation(__spreadValues({
    mutationFn: mutationFnFactory(config),
    onSuccess: (_data, variables) => {
      if (variables.enrolled) {
        queryClient.invalidateQueries(
          creditHealthCacheKey({
            accountId: variables["cipher.accountId"],
            accountIdType: variables.accountIdType
          })
        );
      }
    }
  }, mutationOptions));
}
export {
  useCreditHealthMutation
};
//# sourceMappingURL=creditHealthMutation.js.map
